/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { ReactElement } from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { settingsReducer } from 'app/redux/slices/settings-slice';
import { Provider } from 'react-redux';
import { render } from '@testing-library/react';
import { ISettingsState } from 'app/redux/slices/settings-interface';
import { store as realStore } from 'app/redux/store';

export const renderWithRedux = (
  children: ReactElement,
  {
    preloadedState = {},
    store = configureStore({
      reducer: {
        settings: settingsReducer
      },
      preloadedState: {
        settings: {
          ...realStore.getState().settings,
          ...preloadedState
        }
      }
    })
  }: {
    store?: typeof realStore;
    preloadedState?: Partial<ISettingsState>;
  } = {}
) => {
  return {
    ...render(<Provider store={store}>{children}</Provider>),
    store
  };
};
